<template>
  <div>
    <panel title="服务单" class="mgb10">
      <div class="pd10 mgb20">
        <div class="mgb5 font16">* 明天的服务单</div>
        <div class="content" v-if="tomorrowItems.length != 0">
          <div
            v-for="(item, itemIndex) of tomorrowItems"
            :key="itemIndex"
            :class="
              itemIndex != tomorrowItems.length - 1 ? 'content-item mgb20' : ''
            "
          >
            <el-row class="mgb10">
              <el-col :span="14" class="font14">
                {{ item.serialNo }}
              </el-col>
              <el-col :span="10" class="right font12">
                {{ item.startAt.slice(5, 10) }} ~ {{ item.endAt.slice(5, 10) }}
              </el-col>
            </el-row>

            <el-row class="mgb10">
              <el-col :span="14">
                {{ item.productNo
                }}<span class="font10">({{ item.categoryName }})</span>
              </el-col>
              <el-col :span="10" class="right font12">
                {{ item.quantity }} {{ item.unit }}
              </el-col>
            </el-row>
            <el-row v-if="item.rent != null">
              <el-col :span="14">
                {{ $t("menu.customers") }}：{{ item.rent.customerName }}
              </el-col>
              <el-col :span="10" class="right font12">
                {{ item.rent.shopName }}
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-else class="content noData">
          {{ $t("text.noData") }}
        </div>
      </div>
      <div class="pd10">
        <div class="mgb5 font16">* 后天的服务单</div>
        <div class="content" v-if="afterTomorrowItems.length != 0">
          <div
            v-for="(item, itemIndex) of afterTomorrowItems"
            :key="itemIndex"
            :class="
              itemIndex != afterTomorrowItems.length - 1
                ? 'content-item mgb20'
                : ''
            "
          >
            <el-row class="mgb10">
              <el-col :span="14" class="font14">
                {{ item.serialNo }}
              </el-col>
              <el-col :span="10" class="right font12">
                {{ item.startAt.slice(5, 10) }} ~ {{ item.endAt.slice(5, 10) }}
              </el-col>
            </el-row>
            <el-row class="mgb10">
              <el-col :span="14">
                {{ item.productNo
                }}<span class="font10">({{ item.categoryName }})</span>
              </el-col>
              <el-col :span="10" class="right font12">
                {{ item.quantity }} {{ item.unit }}
              </el-col>
            </el-row>
            <el-row v-if="item.rent != null">
              <el-col :span="14">
                {{ $t("menu.customers") }}：{{ item.rent.customerName }}
              </el-col>
              <el-col :span="10" class="right font12">
                {{ item.rent.shopName }}
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-else class="content noData">
          {{ $t("text.noData") }}
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import { page } from "@/utils/mixins.js";
import workbench from "@/api/workbench.js";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      loading: false,
      tomorrowItems: [],
      afterTomorrowItems: [],
    };
  },
  created() {
    const self = this;
    self.getTomorrowItems();
    self.getAfterTomorrowItems();
  },
  methods: {
    getTomorrowItems() {
      const self = this;
      workbench.serviceItems({ dateType: "tomorrow" }).then(function (res) {
        if (res.status === 200) {
          self.tomorrowItems = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getAfterTomorrowItems() {
      const self = this;
      workbench
        .serviceItems({ dateType: "afterTomorrow" })
        .then(function (res) {
          if (res.status === 200) {
            self.afterTomorrowItems = res.data;
          } else {
            self.sysError();
          }
        });
    },
  },
};
</script>
<style scoped>
.content {
  border-top: 1px solid rgb(233, 231, 231);
  padding: 10px 0px;
}
.content-item {
  border-bottom: 1px dotted rgb(233, 231, 231);
}
</style>